export const IconReplacements: Record<string, string> = {
  conUploadFile1: 'conUploadFile',
  conUploadFile2: 'conUploadFile',
  cuiEyeAssess: 'culEyeAssess',
  culFileStandard: 'cuiFileStandard',
  culCircleChartAlt: 'uiCircleChart',
  uiCircleChartAlt: 'uiCircleChart',
  baseDotsMenuStrong: 'cusDotsMenu',
  baseTransformerStrong: 'cusTransformer',
  baseVesselStrong: 'cusVessel',
  uiCalendarAltStrong: 'fasCalendarAlt',
  uiCaretDownStrong: 'fasCaretDown',
  uiCaretLeftStrong: 'fasCaretLeft',
  uiCaretRightStrong: 'fasCaretRight',
  uiCaretUpStrong: 'fasCaretUp',
  uiChartNetworkStrong: 'fasChartNetwork',
  uiCheckCircleStrong: 'fasCheckCircle',
  uiClockStrong: 'fasClock',
  uiDiamondStrong: 'fasDiamond',
  uiFileStrong: 'fasFile',
  uiFolderStrong: 'fasFolder',
  uiKeyStrong: 'fasKey',
  uiLayerGroupStrong: 'fasLayerGroup',
  uiMapMarkerAltStrong: 'fasMapMarkerAlt',
  uiMapMarkerExclamationStrong: 'fasMapMarkerExclamation',
  uiPuzzlePieceStrong: 'fasPuzzlePiece',
  uiSolarPanelStrong: 'fasSolarPanel',
  uiSortStrong: 'fasSort',
  uiStarStrong: 'fasStar',
  uiWindTurbineStrong: 'fasWindTurbine',
}
